export enum TravelUpsellPermissions {
  ALL = "Travel:Upsells:*",
  READ = "Travel:Upsells:Read",
  WRITE = "Travel:Upsells:Write",
}

export function hasTravelUpsellAccess(userPermissions: string[]): boolean {
  const permissions = [
    TravelUpsellPermissions.READ.toString(),
    TravelUpsellPermissions.WRITE.toString(),
    TravelUpsellPermissions.ALL.toString(),
    "*",
  ];
  return userPermissions.some((permission) => permissions.includes(permission));
}
